import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

export const platformIntegrationIssuesPageQuery = gql`
  query platformIntegrationIssuesPageQuery($appId: ID!) {
    platformIntegration(id: $appId) {
      id
      bugs: issues(typeOf: BUG) {
        count
      }
      features: issues(typeOf: FEATURE_REQUEST) {
        count
      }
    }
  }
`;

interface UseQueryInsightsIssuesProps {
  appId: string;
}

export interface UseQueryInsightsIssuesReturn {
  isLoading: boolean;
  hasError: boolean;
  issues: {
    bugs: {
      totalCount: number;
    };
    features: {
      totalCount: number;
    };
  };
}

const useQueryInsightsIssues = ({
  appId,
}: UseQueryInsightsIssuesProps): UseQueryInsightsIssuesReturn => {
  const { data, loading, error } = useQuery(
    platformIntegrationIssuesPageQuery,
    {
      variables: {
        appId,
      },
    }
  );

  const totalBugs = data?.platformIntegration?.bugs?.count;
  const totalFeature = data?.platformIntegration?.features?.count;

  return {
    isLoading: loading,
    hasError: !!error,
    issues: {
      bugs: {
        totalCount: totalBugs,
      },
      features: {
        totalCount: totalFeature,
      },
    },
  };
};

export default useQueryInsightsIssues;
